import { Component, OnInit, ViewChild, EventEmitter } from "@angular/core";
import { LoginConfigView } from "../login-config.view";

@Component({
    selector: "session-expired-config",
    templateUrl: "./session-expired-config.view.html",
    providers: []
})
export class SessionExpiredConfigView extends LoginConfigView {
}
